/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PharmacySlot, PharmacySlotFromJSON, PharmacySlotFromJSONTyped, PharmacySlotToJSON } from "./";

export const PharmacyDailyOnlineCounselingSlotTypename = "PharmacyDailyOnlineCounselingSlot" as const;

/**
 *
 * @export
 * @interface PharmacyDailyOnlineCounselingSlot
 */
export interface PharmacyDailyOnlineCounselingSlot {
  /**
   *
   * @type {string}
   * @memberof PharmacyDailyOnlineCounselingSlot
   */
  date: string;
  /**
   *
   * @type {Array<PharmacySlot>}
   * @memberof PharmacyDailyOnlineCounselingSlot
   */
  slots: Array<PharmacySlot>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyDailyOnlineCounselingSlot
   */
  readonly __typename?: string;
}

export function PharmacyDailyOnlineCounselingSlotFromJSON(json: any): PharmacyDailyOnlineCounselingSlot {
  return PharmacyDailyOnlineCounselingSlotFromJSONTyped(json, false);
}

export function PharmacyDailyOnlineCounselingSlotFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyDailyOnlineCounselingSlot {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyDailyOnlineCounselingSlotTypename,

    date: json["date"],
    slots: (json["slots"] as Array<any>).map(PharmacySlotFromJSON),
  };
}

export function PharmacyDailyOnlineCounselingSlotToJSON(object?: PharmacyDailyOnlineCounselingSlot | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date: value.date,
    slots: (value.slots as Array<any>).map(PharmacySlotToJSON),
  };
}
